//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    tickets: {},
    freebet: {},
    insuredTickets: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {}
  },
  computed: {
    successful() {
      let statuses = _.map(this.tickets, 'status')
      return _.every(statuses, (i) => i == 'PROCESSED') && _.size(statuses) > 0
    },
    completed() {
      let statuses = _.map(this.tickets, 'status')
      return _.every(statuses, (i) => i != null) && _.size(statuses) > 0
    },
    showResults() {
      if (this.processingStatus) return true
      return false
    },
    processingStatus: {
      get() {
        return this.$store.state.betslip.processingStatus
      },
      set(value) {
        this.$store.commit('betslip/setProcessingStatus', value)
      }
    }
  },
  mounted() {},
  methods: {
    isInsured(ticket) {
      return !!_.get(this.insuredTickets, _.get(ticket, 'uuid'))
    },
    onClickOutside(event) {
      console.log('Clicked outside. Event: ', this.successful, event)
      if (this.successful && !this.$device.isMobile) {
        // this.close();
      }
    },
    async close() {
      this.$emit('close')
    },
    async clear() {
      this.$emit('close')
      this.$store.commit('betslip/clear')
      this.$store.commit('betslip/clearStakes')
      this.$store.commit('betslip/setBetType', 'single')
      this.$store.commit('betslip/setStakeSingle', null)
      this.$store.commit('betslip/setStakeCombi', null)

      this.$store.commit('betslip/toggleBetslip', false)
    }
  }
}
